import {
    useEffect,
    useState
} from "react";
import {
    api,
    API
} from "@/lib/api";

let _cache = null;
let _pending = null;

export async function fetchAllContent() {
    if (_cache) return _cache;
    if (_pending) return _pending;
    _pending = api
        .get("/cms/content")
        .then((r) => {
            const mapped = Object.fromEntries(r.data.map((s) => [s.key, s]));
            if (Object.keys(mapped).length > 0) {
                _cache = mapped;
            }
            _pending = null;
            return mapped;
        })
        .catch(() => {
            _pending = null;
            return {};
        });
    return _pending;
}

export function clearContentCache() {
    _cache = null;
}

export function useContent(key, fallback) {
    const [section, setSection] = useState(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        fetchAllContent().then((all) => {
            if (cancelled) return;
            setSection(all[key] || null);
            setLoaded(true);
        });
        return () => {
            cancelled = true;
        };
    }, [key]);

    const sectionData = section && section.enabled !== false ? section.data : null;
    const data = sectionData !== null && sectionData !== undefined ? sectionData : fallback;
    const enabled = section ? section.enabled !== false : true;
    return {
        data,
        enabled,
        loaded,
        raw: section
    };
}

export const cms = {
    list: () => api.get("/cms/content").then((r) => r.data),
    get: (key) => api.get("/cms/content/" + key).then((r) => r.data),
    upsert: (key, payload) =>
        api.put("/cms/content/" + key, payload).then((r) => {
            clearContentCache();
            return r.data;
        }),
    toggle: (key) =>
        api.post("/cms/content/" + key + "/toggle").then((r) => {
            clearContentCache();
            return r.data;
        }),
    upload: async (file) => {
        const fd = new FormData();
        fd.append("file", file);
        const r = await api.post("/cms/upload", fd, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });
        return {
            ...r.data,
            absolute: API + "/storage" + r.data.url
        };
    },
    resetAll: () =>
        api.post("/cms/content/reset").then((r) => {
            clearContentCache();
            return r.data;
        }),
};